import _asyncToGenerator from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/regenerator/index.js";
import { isClockSkewError } from './isClockSkewError.mjs'; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/**
 * Get retry decider function
 * @param errorParser Function to load JavaScript error from HTTP response
 */

var getRetryDecider = function getRetryDecider(errorParser) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response, error) {
      var _ref2;

      var parsedError, errorCode, statusCode;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(error !== null && error !== void 0)) {
                _context.next = 4;
                break;
              }

              _context.t1 = error;
              _context.next = 7;
              break;

            case 4:
              _context.next = 6;
              return errorParser(response);

            case 6:
              _context.t1 = _context.sent;

            case 7:
              _context.t2 = _ref2 = _context.t1;
              _context.t0 = _context.t2 !== null;

              if (!_context.t0) {
                _context.next = 11;
                break;
              }

              _context.t0 = _ref2 !== void 0;

            case 11:
              if (!_context.t0) {
                _context.next = 15;
                break;
              }

              _context.t3 = _ref2;
              _context.next = 16;
              break;

            case 15:
              _context.t3 = undefined;

            case 16:
              parsedError = _context.t3;
              errorCode = (parsedError === null || parsedError === void 0 ? void 0 : parsedError.code) || (parsedError === null || parsedError === void 0 ? void 0 : parsedError.name);
              statusCode = response === null || response === void 0 ? void 0 : response.statusCode;
              return _context.abrupt("return", isConnectionError(error) || isThrottlingError(statusCode, errorCode) || isClockSkewError(errorCode) || isServerSideError(statusCode, errorCode));

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}; // reference: https://github.com/aws/aws-sdk-js-v3/blob/ab0e7be36e7e7f8a0c04834357aaad643c7912c3/packages/service-error-classification/src/constants.ts#L22-L37


var THROTTLING_ERROR_CODES = ['BandwidthLimitExceeded', 'EC2ThrottledException', 'LimitExceededException', 'PriorRequestNotComplete', 'ProvisionedThroughputExceededException', 'RequestLimitExceeded', 'RequestThrottled', 'RequestThrottledException', 'SlowDown', 'ThrottledException', 'Throttling', 'ThrottlingException', 'TooManyRequestsException'];
var TIMEOUT_ERROR_CODES = ['TimeoutError', 'RequestTimeout', 'RequestTimeoutException'];

var isThrottlingError = function isThrottlingError(statusCode, errorCode) {
  return statusCode === 429 || !!errorCode && THROTTLING_ERROR_CODES.includes(errorCode);
};

var isConnectionError = function isConnectionError(error) {
  return (error === null || error === void 0 ? void 0 : error.name) === 'Network error';
};

var isServerSideError = function isServerSideError(statusCode, errorCode) {
  return !!statusCode && [500, 502, 503, 504].includes(statusCode) || !!errorCode && TIMEOUT_ERROR_CODES.includes(errorCode);
};

export { getRetryDecider };